/* tslint:disable */
/* eslint-disable */
/* @relayHash 1ad9a328100a4777bfee7be2b4bb0f86 */

import { ConcreteRequest } from "relay-runtime";
export type helpers_UpdateUpToMutationVariables = {
    courseID: number;
    upTo?: string | null;
};
export type helpers_UpdateUpToMutationResponse = {
    readonly updateUpTo: {
        readonly updateSuccess: boolean;
        readonly courseCompleted: boolean;
    } | null;
};
export type helpers_UpdateUpToMutation = {
    readonly response: helpers_UpdateUpToMutationResponse;
    readonly variables: helpers_UpdateUpToMutationVariables;
};



/*
mutation helpers_UpdateUpToMutation(
  $courseID: Int!
  $upTo: UUID
) {
  updateUpTo(input: {courseID: $courseID, upTo: $upTo}) {
    updateSuccess
    courseCompleted
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "courseID",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "upTo",
            "type": "UUID",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "updateUpTo",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "input",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "courseID",
                            "variableName": "courseID"
                        },
                        {
                            "kind": "Variable",
                            "name": "upTo",
                            "variableName": "upTo"
                        }
                    ]
                }
            ],
            "concreteType": "UpdateUpToResp",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "updateSuccess",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "courseCompleted",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "helpers_UpdateUpToMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "helpers_UpdateUpToMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "helpers_UpdateUpToMutation",
            "id": null,
            "text": "mutation helpers_UpdateUpToMutation(\n  $courseID: Int!\n  $upTo: UUID\n) {\n  updateUpTo(input: {courseID: $courseID, upTo: $upTo}) {\n    updateSuccess\n    courseCompleted\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '16853239056b3252dea8031b73dbec7a';
export default node;
